import { HTMLAttributes } from 'react'

import { Box, cn } from '@podo-app/design-system-temp'

const BottomStickyContainer = ({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <Box className={cn('sticky bottom-[var(--safe-area-inset-bottom)] bg-white z-40', className)} {...props}>
      {children}
    </Box>
  )
}

export default BottomStickyContainer
